exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.dataContainer[data-v-5b2b7c8b]{\n    width:780px;\n    margin-left: 50px;\n}\n.IndexWidth[data-v-5b2b7c8b] {\n     display:inline-block;\n     width:30px;\n     padding-left: 10px;\n}\n.CarBrandWidth[data-v-5b2b7c8b] {\n     display:inline-block;\n     width:180px;\n}\n.ModelBrandWidth[data-v-5b2b7c8b] {\n     display:inline-block;\n     width:220px;\n     margin-left: 20px;\n}\n.PriorityWidth[data-v-5b2b7c8b] {\n     display:inline-block;\n     width:50px;\n     margin-left: 20px;\n     text-align: right;\n}\n.ActiveWidth[data-v-5b2b7c8b] {\n     display:inline-block;\n     width:50px;\n     margin-left: 20px;\n     text-align: center;\n}\n.btnWidth[data-v-5b2b7c8b]{\n     width:50px;\n     margin-left: 10px;  \n     display:inline-block;\n}\n.glyphiconSize[data-v-5b2b7c8b]{\n    font-size: 1.4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5b2b7c8b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/CarModelAdmin.vue
// module id = 84
// module chunks = 0